import React, { useEffect } from "react";
import { Form, Input, DatePicker, Row, Col, Button, Select } from "antd";
import moment from "moment";

const { Option } = Select;

const PatientForm = ({ form, formData }) => {
  useEffect(() => {
    if (formData) {
      const formattedFormData = {
        ...formData,
        date_of_birth: formData.date_of_birth
          ? moment(formData.date_of_birth)
          : null,
      };
      form.setFieldsValue(formattedFormData);
    }
  }, [formData, form]);

  return (
    <Form form={form} layout="vertical">
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="salutation"
            label="Salutation"
            rules={[
              { required: true, message: "Please enter the salutation!" },
            ]}
          >
            <Select placeholder="Select a salutation">
              <Option value="Mr.">Mr.</Option>
              <Option value="Miss.">Miss.</Option>
              <Option value="Mrs.">Mrs.</Option>
              <Option value="Ms.">Ms.</Option>
              <Option value="Dr.">Dr.</Option>
              <Option value="Prof.">Prof.</Option>
              <Option value="A/Prof.">A/Prof.</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="first_name"
            label="First Name"
            rules={[
              { required: true, message: "Please enter the first name!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="last_name"
            label="Last Name"
            rules={[{ required: true, message: "Please enter the last name!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="phone_number"
            label="Phone Number"
            rules={[
              { required: true, message: "Please enter the phone number!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="email_address"
            label="Email Address"
            rules={[
              { required: true, message: "Please enter the email address!" },
            ]}
          >
            <Input
              disabled
              style={{
                backgroundColor: "#e8e8e8",
                color: "black",
                cursor: "not-allowed",
              }}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="gender"
            label="Gender"
            rules={[{ required: true, message: "Please enter the gender!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="date_of_birth"
            label="Date of Birth"
            rules={[
              { required: true, message: "Please enter the date of birth!" },
            ]}
          >
            <DatePicker format="YYYY-MM-DD" />
          </Form.Item>
        </Col>
      </Row>
      <Form.List name="allergies">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, fieldKey, ...restField }) => (
              <Row gutter={16} key={key}>
                <Col span={7}>
                  <Form.Item
                    {...restField}
                    name={[name, "allergy_type"]}
                    fieldKey={[fieldKey, "allergy_type"]}
                    label="Allergy Type"
                    rules={[
                      { required: true, message: "Missing allergy type" },
                    ]}
                  >
                    <Select placeholder="Select allergy type">
                      <Option value="drug">Drug</Option>
                      <Option value="no known drug allergy">
                        No Known Drug Allergy
                      </Option>
                      <Option value="food">Food</Option>
                      <Option value="no known food allergy">
                        No Known Food Allergy
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    {...restField}
                    name={[name, "allergy"]}
                    fieldKey={[fieldKey, "allergy"]}
                    label="Allergy"
                    rules={[{ message: "Missing allergy" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    {...restField}
                    name={[name, "reaction"]}
                    fieldKey={[fieldKey, "reaction"]}
                    label="Reaction"
                    rules={[{ message: "Missing reaction" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={3}>
                  <Form.Item
                    {...restField}
                    name={[name, "severity"]}
                    fieldKey={[fieldKey, "severity"]}
                    label="Severity"
                    rules={[
                      { required: true, message: "Input should be 1, 2 or 3" },
                    ]}
                    getValueFromEvent={(value) => Number(value.target.value)}
                  >
                    <Input type="number" min={1} max={3} />
                  </Form.Item>
                </Col>
                <Col span={1}>
                  <Button type="link" onClick={() => remove(name)}>
                    Remove
                  </Button>
                </Col>
              </Row>
            ))}
            <Form.Item>
              <Button type="dashed" onClick={() => add()} block>
                Add Allergy
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default PatientForm;
